import { useState, useEffect } from "react";

const navLinks = [
  { label: "Início", href: "#hero" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos" },
  { label: "Como Funciona", href: "#como-funciona" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

const WHATSAPP_URL = "https://wa.me/5598992018216?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20meus%20direitos%20previdenci%C3%A1rios.";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-[#0B4D6F] shadow-md" : "bg-white shadow-sm"
        }`}
        style={{ height: "80px" }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-full flex items-center justify-between">

          {/* Mobile: espaço à esquerda para balancear o hamburger e centralizar a logo */}
          <div className="md:hidden w-10" />

          {/* Logo — centralizada no mobile, alinhada à esquerda no desktop */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick("#hero"); }}
            className="flex items-center cursor-pointer md:flex-none absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0"
          >
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/1e89a5bd7d914e799e14a1aa4f84e2d1.png"
              alt="Jordanna Rates Advocacia Previdenciária"
              style={{ height: "72px", width: "auto" }}
              className="object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <ul className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="font-medium text-sm cursor-pointer transition-colors duration-200"
                  style={{
                    fontFamily: "Montserrat, sans-serif",
                    color: scrolled ? "#FFFFFF" : "#0B4D6F",
                  }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = scrolled ? "#F2ECD4" : "#0B4D6F"; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = scrolled ? "#FFFFFF" : "#0B4D6F"; }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:opacity-90"
            style={{
              backgroundColor: scrolled ? "#FFFFFF" : "#0B4D6F",
              color: scrolled ? "#0B4D6F" : "#FFFFFF",
              border: "2px solid transparent",
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            <i className="ri-whatsapp-line text-base"></i>
            Falar no WhatsApp
          </a>

          {/* Mobile: hamburger à direita */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="w-10 h-10 flex items-center justify-center rounded-md cursor-pointer"
              aria-label="Abrir menu"
            >
              <i
                className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}
                style={{ color: scrolled ? "#FFFFFF" : "#0B4D6F" }}
              ></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-all duration-300 ${menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      >
        {/* Top solid white panel */}
        <div
          className="absolute top-0 left-0 right-0 bg-white shadow-lg"
          style={{ paddingTop: "80px", paddingBottom: "44px" }}
        >
          <ul className="flex flex-col items-center gap-1 px-6">
            {navLinks.map((link) => (
              <li key={link.href} className="w-full">
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="block text-center py-4 text-base font-medium cursor-pointer border-b border-gray-100 transition-colors hover:text-[#0B4D6F]"
                  style={{ fontFamily: "Montserrat, sans-serif", color: "#1A1A1A" }}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="w-full pt-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-center gap-2 w-full py-3.5 rounded-full text-white font-semibold cursor-pointer"
                style={{ backgroundColor: "#0B4D6F", fontFamily: "Montserrat, sans-serif" }}
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Falar no WhatsApp
              </a>
            </li>
          </ul>
        </div>
        {/* Bottom blur overlay */}
        <div
          className="absolute bottom-0 left-0 right-0"
          style={{
            top: "auto",
            height: "40%",
            backdropFilter: "blur(20px)",
            backgroundColor: "rgba(0,0,0,0.25)",
          }}
          onClick={() => setMenuOpen(false)}
        />
      </div>
    </>
  );
}
